/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { isEmpty, isNil } from "ramda";

import { MapContainer, TileLayer, Marker, Polyline, useMap, Polygon, Circle, Pane, Popup } from "react-leaflet";
import { IS_ONLINE, MAP_TYPES } from "../../../../../config/configmap";
import { Icon } from "leaflet";
import L from "leaflet";

import { PlayBar } from "./styled";
import { Box, Button, LinearProgress } from "@mui/material";
import palette, { polylineColors } from "../../../../../config/colorPalette";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import ReplayIcon from "@mui/icons-material/Replay";
import { getShipTrackingHistorial } from "../../../../api";

const MapAlert = ({ assetData, assetEquipments, points, alert, intl }) => {
  const mapType = "regular";
  const [polyline, setPolyline] = useState([]);
  const [alertPosition, setAlertPosition] = useState([]);
  const severities = ["low", "intermediate", "high"];
  const headings = {
    N: 0,
    NNE: 22.5,
    NE: 45,
    ENE: 67.5,
    E: 90,
    ESE: 112.5,
    SE: 135,
    SSE: 157.5,
    S: 180,
    SSO: 202.5,
    SO: 225,
    OSO: 247.5,
    O: 270,
    ONO: 292.5,
    NO: 315,
    NNO: 337.5,
  };
  const [polygonCritical, setPolygonCritical] = useState(null);
  const [polygonProtect, setPolygonProtect] = useState(null);
  const [polygonAvoid, setPolygonAvoid] = useState(null);
  const [polygonExtra, setPolygonExtra] = useState(null);
  const [rutas, setRutas] = useState(null);
  const [shipPosition, setShipPosition] = useState(null); // esto sera un array de arrays, con posiciones de los barcos, a la espera de jon
  useMemo(async () => {
    const newCrit = [];
    const newAvoid = [];
    const newProt = [];
    const newExtra = [];
    const equipment = assetEquipments?.find((item) => item.equipmentID === alert.equipmentID);
    if (!isNil(alert) && alert.package === "submarine_impact") {
      const response = [];
      const ships = [];
      for (let indexTracking = 0; indexTracking < alert.moreInfo.impacts?.length; indexTracking++) {
        const res = await getShipTrackingHistorial(
          alert.moreInfo.impacts[indexTracking].tracking_id,
          alert.moreInfo.impacts[indexTracking].ship_id,
          alert.dateStart,
          alert.dateEnd,
        );
        response.push(res.data.data[0]);
        const ship = {
          trackingId: alert.moreInfo.impacts[indexTracking].tracking_id,
          shipId: alert.moreInfo.impacts[indexTracking].ship_id,
          coords: [
            alert.moreInfo.impacts[indexTracking].last_coords[1],
            alert.moreInfo.impacts[indexTracking].last_coords[0],
          ],
          datetime: alert.moreInfo.impacts[indexTracking].datetime,
          speed: alert.moreInfo.impacts[indexTracking].speed,
          name: alert.moreInfo.impacts[indexTracking].ship_info.name,
          heading: headings[alert.moreInfo.impacts[indexTracking].direction],
        };
        ships.push(ship);
      }
      setShipPosition(ships);
      setRutas(response);
      if (!isNil(equipment)) {
        if (!isEmpty(equipment.areas)) {
          for (let areaIndex = 0; areaIndex < equipment.areas.main?.length; areaIndex++) {
            newCrit.push(equipment.areas.main[areaIndex].critical.geometry.coordinates);
            newProt.push(equipment.areas.main[areaIndex].protection.geometry.coordinates);
          }
          for (let indexAvoid = 0; indexAvoid < equipment.areas.avoid?.length; indexAvoid++) {
            newAvoid.push(equipment.areas.avoid[indexAvoid]);
          }
          for (let indexExtra = 0; indexExtra < equipment.areas.extra?.length; indexExtra++) {
            newExtra.push(equipment.areas.extra[indexExtra]);
          }
        }
        setPolygonCritical(newCrit);
        setPolygonAvoid(newAvoid);
        setPolygonProtect(newProt);
        setPolygonExtra(newExtra);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alert.equipmentID, assetEquipments]);

  const intervalRef = useRef(null);
  const [progress, setProgress] = useState(0);

  /*
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const playRoute = () => {
    if (intervalRef.current) return;

    setIsPlaying(true);

    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => {
        const next = prev + 1;

        if (next >= rutas.length) {
          pauseRoute();
          return prev;
        }

        setShipPosition([rutas[next].lat, rutas[next].lng]);
        setProgress(((next + 1) / rutas.length) * 100);

        return next;
      });
    }, 1000);
  };
  const pauseRoute = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setIsPlaying(false);
  };
  const restartRoute = () => {
    pauseRoute();
    setCurrentIndex(0);
    setShipPosition([rutas[0].lat, rutas[0].lng]);
    setProgress(0);
  };*/

  const customIcon = new Icon({
    iconUrl: require(
      `../../../../../images/Uptech-marker-alerts-icon-${severities[alert.severity - 1]}-${alert.package}.png`,
    ),
    iconSize: [60, 60],
    iconAnchor: [27, 60],
  });
  const createShipIcon = (type, heading, extra) =>
    L.divIcon({
      className: "",
      html: `
      <div style="position: relative; width: 30px; height: 30px;">
        <img 
          src="${require(`../../../../../images/ship-${type}.png`)}"
          style="transform: rotate(${heading}deg); width: 30px; height: 30px;"
        />

        ${
          extra !== ""
            ? `
              <img
                src="${require(`../../../../../images/${extra}.png`)}"
                style="
                  position: absolute;
                  top: 5px;
                  right: 7px;
                  width: 12px;
                  height: 12px;
                  z-index: 10;
                "
              />
            `
            : ""
        }
      </div>
    `,
      iconSize: [30, 30],
    });

  useEffect(() => {
    if (!isNil(alert) && !isNil(points) && isEmpty(polyline)) {
      const equipment = assetData.equipments.find((equip) => equip.equipmentID === alert.equipmentID);
      const actualSub = equipment.channels[alert.channel - 1].substructures.find(
        (sub) => sub.name === alert.substructure,
      );
      const assetChannelPoints = points.data[`${alert.asset}${actualSub.polyline + 1}`];
      const newPoints = [];
      if (!isNil(assetChannelPoints)) {
        for (let pIndex = 0; pIndex < assetChannelPoints.must_graph_points.length; pIndex++) {
          newPoints.push(assetChannelPoints.points[assetChannelPoints.must_graph_points[pIndex]]);
        }
        setAlertPosition([
          points.data[`${alert.asset}${alert.channel}`].points[alert.startIndex].latitude,
          points.data[`${alert.asset}${alert.channel}`].points[alert.startIndex].longitude,
        ]);
        setPolyline(newPoints);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alert, points]);

  function ChangeView() {
    const mapView = useMap();
    useEffect(() => {
      mapView.dragging.enable();
      mapView.scrollWheelZoom.enable();
      mapView.doubleClickZoom.enable();
      mapView.boxZoom.enable();
      mapView.keyboard.enable();

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mapView]);

    if (!isEmpty(alertPosition)) {
      mapView.setMaxBounds(null);
      mapView.setView(alertPosition, 15, { reset: false });
    }

    return null;
  }

  return (
    <MapContainer
      id="map-for-alert"
      style={{ width: "50%", height: "30rem" }}
      center={assetData.centroid}
      zoom={11}
      rotateControl={false}
    >
      <TileLayer
        attribution={window.RUNTIME_CONFIG.IS_ONLINE ? "Google Maps" : "OpenStreetMap"}
        url={window.RUNTIME_CONFIG.MAP_TYPES.find((type) => type.value === mapType).tileLayer}
        maxZoom={18}
        subdomains={["mt0", "mt1", "mt2", "mt3"]}
      />
      <Pane name="polygonsPane" style={{ zIndex: 400 }} />
      <Pane name="linesPane" style={{ zIndex: 500 }} />
      <ChangeView />
      {!isNil(alert) && !isEmpty(alertPosition) && (
        <Marker key={assetData.name} position={alertPosition} icon={customIcon}></Marker>
      )}
      {polyline.map((line, lineIndex) => {
        if (lineIndex === 0) return null;
        return (
          <Polyline
            key={`${alert.application}-${alert.asset}-${lineIndex}`}
            positions={[
              [polyline[lineIndex - 1].latitude, polyline[lineIndex - 1].longitude],
              [line.latitude, line.longitude],
            ]}
            weight={5}
            color={polylineColors[0]}
            pane="linesPane"
          ></Polyline>
        );
      })}
      {!isNil(alert) &&
        alert.package === "submarine_impact" &&
        !isNil(rutas) &&
        rutas.map((ruta, rutaIndex) => {
          return ruta.polylines.map((polyline, polylineLineIndex) => {
            return polyline.coords.map((line, lineIndex) => {
              if (lineIndex === 0) return null;
              return (
                <Polyline
                  key={`${alert.application}-${alert.asset}-${polylineLineIndex}-${lineIndex}_ruta${rutaIndex}`}
                  positions={[
                    [polyline.coords[lineIndex - 1][0][0], polyline.coords[lineIndex - 1][0][1]],
                    [line[0][0], line[0][1]],
                  ]}
                  weight={5}
                  color={rutas.length > 9 ? "#02429c" : polylineColors[rutaIndex + 1]}
                  pane="linesPane"
                ></Polyline>
              );
            });
          });
        })}
      {!isNil(shipPosition) &&
        !isEmpty(shipPosition) &&
        shipPosition.map((ship, shipIndex) => (
          <Marker
            key={assetData.name + "ship" + shipIndex + ship.shipId}
            position={ship.coords}
            icon={createShipIcon(
              isNil(ship.type) ? "unspecified" : ship.type,
              isNil(ship.heading) ? 45 : ship.heading,
              "",
            )}
          >
            <Popup>
              <div style={{ width: "15rem" }}>
                <h1>MMSI: {ship.shipId}</h1>
                <h1>
                  {intl.formatMessage({ id: "name" })}: {ship.name}
                </h1>
                <h2>
                  {intl.formatMessage({ id: "speed" })}: {ship.speed} km/h
                </h2>
              </div>
            </Popup>
          </Marker>
        ))}
      {!isNil(polygonCritical) &&
        !isEmpty(polygonCritical) &&
        polygonCritical.map((crit, polyIndex) => (
          <Polygon positions={crit} key={`crit${polyIndex}`} pane="polygonsPane" pathOptions={{ color: "red" }} />
        ))}
      {!isNil(polygonAvoid) &&
        !isEmpty(polygonAvoid) &&
        // eslint-disable-next-line array-callback-return
        polygonAvoid.map((avoid, polyIndex) => {
          if (avoid.geometry.type === "Polygon") {
            return (
              <Polygon
                positions={avoid.geometry.coordinates}
                key={`avoid${polyIndex}`}
                pane="polygonsPane"
                pathOptions={{ color: "white" }}
              />
            );
          } else if (avoid.geometry.type === "Point") {
            return (
              <Circle
                key={`avoid${polyIndex}`}
                radius={avoid.distance}
                center={avoid.geometry.coordinates}
                pane="polygonsPane"
                pathOptions={{ color: "white" }}
              />
            );
          }
        })}
      {!isNil(polygonExtra) &&
        !isEmpty(polygonExtra) &&
        // eslint-disable-next-line array-callback-return
        polygonExtra.map((extra, polyIndex) => {
          if (extra.geometry.type === "polygon") {
            return (
              <Polygon
                positions={extra.geometry.coordinates}
                key={`extra${polyIndex}`}
                pane="polygonsPane"
                pathOptions={{ color: "red" }}
              />
            );
          } else if (extra.geometry.type === "Point") {
            return (
              <Circle
                key={`extra${polyIndex}`}
                radius={extra.distance}
                center={extra.geometry.coordinates}
                pane="polygonsPane"
                pathOptions={{ color: "red" }}
              />
            );
          }
        })}
      {!isNil(polygonProtect) &&
        !isEmpty(polygonProtect) &&
        polygonProtect.map((prot, polyIndex) => (
          <Polygon positions={prot} key={`prot${polyIndex}`} pane="polygonsPane" pathOptions={{ color: "green" }} />
        ))}
      {
        //BARRA DE REPRODUCCION
        /*      <PlayBar>
        {!isPlaying ? (
          <Button
            variant="contained"
            id="play"
            style={{
              backgroundColor: palette.primary,
              color: "white",
            }}
            onClick={playRoute}
          >
            <PlayArrowIcon />
          </Button>
        ) : (
          <Button variant="contained" onClick={pauseRoute}>
            <PauseIcon />
          </Button>
        )}
        <Button variant="contained" onClick={restartRoute} sx={{ marginLeft: "1%" }}>
          <ReplayIcon />
        </Button>
        <Box sx={{ width: "100%", marginTop: "2%", marginLeft: "1%" }}>
          <LinearProgress variant="determinate" value={progress} onClick={(e) => console.log(e, e.target)} />
        </Box>
      </PlayBar>
      {!isNil(alert) && !isEmpty(shipPosition) && (
        <Marker key={assetData.name + "ship"} position={shipPosition} icon={customOkIcon}></Marker>
      )} */
      }
    </MapContainer>
  );
};

export default MapAlert;
